import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { MediaSearchResult } from './MediaSearchResult';
import { MediaSearchResultPlaceholder } from './MediaSearchResultPlaceholder';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { times } from '../../../../../play-core/utils/times';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaSearchResultList = ({
  medias,
  isLoading,
  isDownloadFilterActive,
  order,
  searchTerm,
  previousPage
}) => /*#__PURE__*/_jsx(PlayContainer, {
  width: "small",
  sidePadding: {
    default: 0,
    mediaQuery: []
  },
  children: /*#__PURE__*/_jsx(List, {
    children: isLoading ? /*#__PURE__*/_jsx(Placeholder, {}) : medias.map((media, index) => /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(MediaSearchResult, {
        resultIndex: index,
        media: media,
        isDownloadFilterActive: isDownloadFilterActive,
        order: order,
        searchTerm: searchTerm,
        previousPage: previousPage
      })
    }, media.id))
  })
});
const Placeholder = () => /*#__PURE__*/_jsx(Fragment, {
  children: times(15, index => /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(MediaSearchResultPlaceholder, {})
  }, index))
});
const List = styled.ul.withConfig({
  displayName: "MediaSearchResultList__List",
  componentId: "sc-379ejp-0"
})(["list-style:none;margin:0;padding:30px 0 0 0;width:100%;", "{padding:0;}"], Viewports.for('small'));
const ListItem = styled.li.withConfig({
  displayName: "MediaSearchResultList__ListItem",
  componentId: "sc-379ejp-1"
})(["margin-bottom:14px;width:100%;", "{margin-bottom:0;}"], Viewports.for('small'));